import { useTranslation } from "react-i18next";
import { ReactComponent as Logo } from "shared/assets/images/logo-strm.svg";
import { ReactComponent as HomeIcon } from "shared/assets/images/home-icon.svg";
import { ReactComponent as RankingIcon } from "shared/assets/images/ranking-icon.svg";
import { ReactComponent as ArtistIcon } from "shared/assets/images/artist-icon.svg";
import { ReactComponent as ComparisonIcon } from "shared/assets/images/label-icon.svg";
import { ReactComponent as ComparisoIcon } from "shared/assets/images/comparison-icon.svg";
// import { ReactComponent as TrendIcon } from "shared/assets/images/trend-icon.svg";
import { ReactComponent as TourIcon } from "shared/assets/images/tutorial-icon.svg";
import { ReactComponent as LogoutIcon } from "shared/assets/images/logout-icon.svg";
import { ReactComponent as SettingsIcon } from "shared/assets/images/settings-icon.svg";
import { ReactComponent as LabelProfileIcon } from "shared/assets/images/diagnose-icon.svg";
import { ReactComponent as DiagnosticIcon } from "shared/assets/images/diagnostic-icon.svg";
import { ReactComponent as DistroIcon } from "shared/assets/images/icon-distro.svg";
import { ReactComponent as LabelManagementIcon } from "shared/assets/images/icon-my-labels.svg";
import { Link, useHistory } from "react-router-dom";
import { Layout, Menu } from "antd";
import { LanguageChange } from "shared/components";
import { logout } from "shared/helpers/auth-functions";
import "./MenuLateralRadar.scss";
import { useSelector } from "react-redux";
import { UserStatus } from "shared/enums/UserStatus";
import { isEnableFullDiagnostic } from "shared/helpers/full-diagnostic-helpers";
import { ArtistState } from "explorer/reducers/artistas";
import { openInNewTab } from "shared/helpers/external-url-helper";
const { Sider } = Layout;

const MenuLateralRadar = () => {
  const { t } = useTranslation("radar");
  const { loggedUser } = useSelector((state: any) => state.users);
  const history = useHistory();
  const { distroToken } = useSelector((state: ArtistState) => state.artists);

  const onClickDistro = () => {
    const revelatorSite = process.env.REACT_APP_REVELATOR_SITE;
    if (revelatorSite && distroToken) {
      const url = `${revelatorSite}authorize?token=${distroToken}`;
      openInNewTab(url);
    }
  };

  return (
    <Sider
      collapsible
      trigger={null}
      style={{ minHeight: "100vh" }}
      collapsed={true}
      className="menu"
      width={230}
    >
      <div>
        <div className="logo">
          <Logo
            style={{ width: 64, cursor: "pointer" }}
            onClick={() => history.push("/")}
          />
        </div>
        <Menu mode="inline" selectedKeys={[history?.location?.pathname]}>
          <Menu.Item key="/" icon={<HomeIcon />}>
            <Link to="/">{t("components.MenuLateralRadar.home")}</Link>
          </Menu.Item>
          <Menu.Item
            key="/artist-ranking"
            icon={<RankingIcon />}
            data-tour="step-1"
          >
            <Link to="/artist-ranking">
              {t("components.MenuLateralRadar.ranking")}
            </Link>
          </Menu.Item>
          <Menu.Item
            key="/artist-profile"
            icon={<ArtistIcon />}
            data-tour="step-2"
          >
            <Link to="/artist-profile">
              {t("components.MenuLateralRadar.artistProfile")}
            </Link>
          </Menu.Item>

          <Menu.Item
            key="/comparison"
            icon={<ComparisonIcon />}
            data-tour="step-3"
          >
            <Link to="/comparison">
              {t("components.MenuLateralRadar.comparison")}
            </Link>
          </Menu.Item>
          <Menu.Item
            key="/label-profile"
            icon={<LabelProfileIcon className="stroke-active" />}
            data-tour="step-2"
          >
            <Link to="/label-profile">
              {t("components.MenuLateralRadar.labelProfile")}
            </Link>
          </Menu.Item>
          {/* <Menu.Item
            key="/trends"
            icon={<TrendIcon className="stroke-active" />}
            data-tour="step-4"
          >
            <Link to="/trends">
              {t("components.MenuLateralRadar.topSpotify")}
            </Link>
          </Menu.Item> */}
          {isEnableFullDiagnostic(loggedUser) && (
            <Menu.Item
              key="/diagnostic"
              icon={<DiagnosticIcon className="stroke-active" />}
            >
              <Link to="/diagnostic">
                {t("components.MenuLateralRadar.diagnose")}
              </Link>
            </Menu.Item>
          )}
          {distroToken && (
            <Menu.Item
              key="/distro"
              icon={<DistroIcon />}
              onClick={onClickDistro}
            >
              {t("components.MenuLateralRadar.distro")}
            </Menu.Item>
          )}
          {loggedUser.specialCampaignTeam && (
            <Menu.Item
              key="/label-management"
              icon={
                <span className="label-management-menu">
                  <LabelManagementIcon className="label-management-active" />
                </span>
              }
            >
              <Link to="/label-management">
                {t("components.MenuLateralRadar.labelManagement")}
              </Link>
            </Menu.Item>
          )}
        </Menu>
      </div>

      <LanguageChange.SelectLanguageChange />
      <span
        style={{
          borderBottom: "1px solid #3F3F3F",
          margin: "0 8px 16px 8px",
          padding: "0 24px",
        }}
      />
      <div>
        <Menu mode="inline" selectedKeys={[history?.location?.pathname]}>
          <Menu.Item
            key="/meus-dados"
            icon={<ComparisoIcon className="stroke-active" />}
          >
            <Link to="/meus-dados">
              {t("components.MenuLateralRadar.meusDados")}
            </Link>
          </Menu.Item>

          {[UserStatus.AdminTeam].includes(loggedUser.status) && (
            <Menu.Item
              key="/team-configuration"
              icon={<SettingsIcon className="stroke-active" />}
            >
              <Link to="/team-configuration">
                {t("components.MenuLateralRadar.settings")}
              </Link>
            </Menu.Item>
          )}

          <Menu.Item key="/tutorial" icon={<TourIcon />} data-tour="step-5">
            <Link to="tutorial">
              {t("components.MenuLateralRadar.tutorial")}
            </Link>
          </Menu.Item>
          <Menu.Item
            key="7"
            icon={<LogoutIcon />}
            onClick={() => logout(false)}
          >
            {t("components.MenuLateralRadar.logout")}
          </Menu.Item>
        </Menu>
      </div>
    </Sider>
  );
};

export default MenuLateralRadar;
